import { render, staticRenderFns } from "./schedule-widgets.vue?vue&type=template&id=ed04d988"
import script from "./schedule-widgets.vue?vue&type=script&lang=js"
export * from "./schedule-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports